// matches the current value against the list of values, returns back the string for it

export function matchValue(current, values, strings) {
  for (var i=0; i < values.length; i++) {
    if (current == values[i]) {
      return (strings[i])
    }
  }
  return ("Not Found")
}
